import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import TestGeneralFeedbackElement from './TestGeneralFeedbackElement'
import generalFeedback from './assets/generalFeedback.svg'

export default genElementConfig(CONFIG_ELEMENTS.testGeneralFeedback, {
  label: t('elements.testGeneralFeedback.label'),
  icon: generalFeedback,
  group: ElementGroup.test,
  styleFields: null,
  Element: TestGeneralFeedbackElement,
  Demo: [],
  FormValue: null,
  FormBrand: null,
  EditorActions: null,
})
